<template>
  <div class="precision-drive-scene">
    <!-- 顶部宣传区域（保持原结构） -->
    <div class="top-banner">
      <div class="top-banner-text">
        <div class="banner-content">
          <h2 class="title">{{ shoppingMallData.title }}</h2>
          <h1 class="main-title" v-html="shoppingMallData.mainTitle"></h1>
          <div class="icon-list">
            <div class="icon-item">
              <span>{{ shoppingMallData.content }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main-width">
      <!-- 标题区域（移除内联style，用class保持原样式） -->
      <div class="introduce-header">
        <div class="introduce-title">{{ shoppingMallData.productTitle }}
          <span class="highlight"> {{ shoppingMallData.productHighlight }} </span>
        </div>
        <span class="xiahuaxian"></span>
      </div>
      <!-- 推荐产品列表（保持原结构） -->
      <div class="info-container">
        <div v-for="(product, index) in productList" :key="index" class="info-player">
          <div class="product-img-box">
            <img :src="$VUE_APP_BASE_API + product.pic" alt="加载中..." height="143px">
          </div>
          <div class="product-name">{{ product.name }}</div>
          <div class="product-info">
            <div class="product-info-item">{{ product.proDescribe }}</div>
          </div>
          <div class="buy-btn">
            <el-button type="text" @click="handleDetail(product)" icon="el-icon-goods">{{ $t('shoppingMall.buy') }}</el-button>
<!--            <el-button type="text" @click="(product)" icon="el-icon-goods">{{ $t('shoppingMall.buy') }}</el-button>-->
          </div>
        </div>
      </div>
      <!-- 商品分类列表（保持原结构） -->
<!--      <div class="container-product">-->
<!--        <div v-for="(pro, pIndex) in productSamples" :key="pIndex" class="product-category">-->
<!--          <div class="pro-sample">-->
<!--            <div class="pro-sampleName">{{ pro.name }}</div>-->
<!--            <div class="category-img-box">-->
<!--              <img :src="$VUE_APP_BASE_API + pro.icon" alt="加载中..." width="224px" height="300px" />-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="category-product-list">-->
<!--            <div v-for="(sample, sIndex) in pro.productVOS" :key="sIndex" class="sample-info"-->
<!--              @click="handleDetail(sample)">-->
<!--              <div style="padding: 5px">-->
<!--                <img :src="$VUE_APP_BASE_API + sample.pic" alt="加载中..." style="max-width: 50%; height: auto;"/>-->
<!--              </div>-->
<!--              <div class="sample-name">{{ sample.name }}</div>-->
<!--              <div class="product-info-item-d">{{ sample.proDescribe }}</div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
    </div>
<!--    <a href="https://work.weixin.qq.com/kfid/kfcf76139c1c83456b7" target="_blank"-->
<!--       style="position:fixed;-->
<!--       right:30px;-->
<!--       bottom:50px;-->
<!--       background:#0084ff;-->
<!--       color:white;-->
<!--       padding:12px 20px;-->
<!--       border-radius:50px;-->
<!--       text-decoration:none;-->
<!--       box-shadow:0 2px 8px rgba(0,0,0,0.2);">-->
<!--      客服咨询-->
<!--    </a>-->
  </div>
</template>

<script>
import { getShoppingCategoryList, getShoppingList, getShoppingMallByOne } from "@/api/sysytem/shopping";

export default {
  name: 'shoppingMall',
  data() {
    return {
      concept: '我们将以优质的产品，可靠的质量，优越的终生效能费用比和有效的服务，满足旋转加工领域日益增长的主轴需求。',
      shoppingMallData: {
        title: '',
        mainTitle: '',
        content: '',
        productTitle: '',
        productHighlight: ''
      },
      productList: [
        {
          model: 'MFW-665',
          diameter: 60,
          maxSpeed: 65000,
          interface: 'HSK-E20',
          lubrication: '油脂润滑',
          powerS1: '2.00/4.80kW',
          torqueS1: '0.30/0.72Nm',
          img: require('@/assets/img/chanpin3.png'),
          isCompared: false
        }
      ],
      productSamples: []
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.getShoppingMallData()
      this.getShoppingList()
      getShoppingCategoryList({ publishStatus: 1 }).then(res => {
        this.productSamples = res.data.filter(item => item.productVOS.length > 0);
      })
    },
    getShoppingMallData() {
      getShoppingMallByOne({}).then(res => {
        //console.log('res.data:', res.data)
        if (res && res.data) {
          // console.log('准备赋值的数据:', {
          //   title: res.data.title,
          //   mainTitle: res.data.mainTitle,
          //   content: res.data.content,
          //   productTitle: res.data.productTitle,
          //   productHighlight: res.data.productHighlight
          // })
          this.shoppingMallData = {
            title: res.data.title,
            mainTitle: res.data.mainTitle,
            content: res.data.content,
            productTitle: res.data.productTitle,
            productHighlight: res.data.productHighlight
          }
        } else {
        }
      }).catch(err => {
      })
    },
    getShoppingList() {
      const query = { publishStatus: 1 };
      const pageReq = { page: 0, size: 4 };
      getShoppingList(query, pageReq).then(res => {
        this.productList = res.data
      });
    },
    handleDetail(product) {
      this.$router.push({ path: '/waresDetails', query: { outProductId: product.outProductId, id: product.id } });
    },
  }
}
</script>

<style scoped>

.precision-drive-scene {
  background-color: #000;
  overflow: hidden;
}

/* 顶部宣传区域 */
.top-banner {
  color: #fff;
  width: 100%;
  height: 360px;
  margin: auto;
  background-image: url("@/assets/img/shangchengxin.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  justify-content: center;
}

.top-banner-text {
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  /* 增加左右内边距，避免小屏内容贴边 */
  position: relative;
  width: 100%;
  max-width: 1130px;
  /* 最大宽度保持原尺寸 */
}

.banner-content {
  max-width: 500px;
}

.title {
  font-size: 18px;
  margin: 0 0 8px;
  opacity: 0.8;
}

.main-title {
  font-size: 36px;
  margin: 0 0 16px;
  font-weight: bold;
}

.icon-list {
  display: flex;
  gap: 20px;
}

.icon-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.icon-item span {
  font-size: 14px;
}

/* 主体容器 */
.main-width {
  width: 100%;
  max-width: 1165px;
  /* 与serviceRepair保持一致的最大宽度 */
  margin: auto;
  padding: 0 20px;
  /* 统一左右内边距 */
  box-sizing: border-box;
  /* 确保内边距不影响宽度计算 */
}

/* 标题区域（原样式不变） */
.introduce-header {
  color: #fff;
  margin-top: 130px;
}

.introduce-title {
  font-family: Noto Sans SC, Noto Sans SC;
  font-weight: 400;
  font-size: 24px;
  color: #FFFFFF;
  font-style: normal;
  text-transform: none;
  margin-bottom: 10px;
}

.highlight {
  color: #006BFF;
}

.xiahuaxian {
  display: inline-block;
  width: 96px;
  height: 4px;
  background: #006BFF;
  border-radius: 5px;
  margin-bottom: 10px;
}

/* 推荐产品列表 */
.info-container {
  width: 100%;
  /* 改为100%适应父容器 */
  max-width: 1165px;
  /* 与serviceRepair保持一致 */
  margin: auto;
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  padding: 0;
  /* 移除额外内边距 */
  box-sizing: border-box;
}


.info-player {
  width: 250px;
  height: 330px;
  background-color: #151516;
  /* padding: 10px 15px; */
}

.product-img-box {
  height: 60%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.product-name {
  height: 40px;
  line-height: 40px;
  margin-top: 10px;
  color: #FFFFFF;
  font-weight: bold;
  margin-left: 20px;
  font-size: 16px;
}

.product-info {
  height: 45px;
  margin-left: 20px;
}

.product-info-item {
  font-size: 12px;
  color: #FFFFFF;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  white-space: normal;
}
.product-info-item-d{
  margin-left: 5px;
  margin-right: 5px;
  font-size: 12px;
  color: #FFFFFF;
  opacity: 0.5;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  white-space: normal;
}

.buy-btn {
  text-align: center;
}

.buy-btn .el-button {
  color: #006BFF;
  font-size: 16px;
}

/* 商品分类列表（原样式不变） */
.container-product {
  overflow: hidden;
  margin-top: 70px;
}

.product-category {
  display: flex;
  gap: 15px;
  margin-bottom: 30px;
}

.pro-sample {
  position: relative;
}

.pro-sampleName {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 24px;
  color: #fff;
  font-weight: bold;
  text-align: center;
  z-index: 2;
}

.category-img-box {
  width: 224px;
  height: 300px;
}

.category-product-list {
  display: flex;
  gap: 15px;
}

.sample-info {
  width: 224px;
  height: 100%;
  background-color: #151516;
  text-align: center;
  /* padding: 20px; */
  cursor: pointer;
}

.sample-name {
  font-size: 16px;
  font-weight: bold;
  margin: 20px;
  color: #FFFFFF;
}

@media (max-width: 1200px) {
  .top-banner {
    width: 100%;
    height: 450px;
    /* 保留原高度，避免背景变形 */
  }

  .banner-content {
    width: 100%;
    max-width: 1165px;
    /* 与主容器保持一致 */
    padding: 74px 20px 324px;
    /* 使用统一内边距 */
    margin: 0 auto;
    /* 居中显示 */
  }

  .main-width,
  .info-container {
    width: 90%;
  }
}

@media (max-width: 992px) {
  .product-category {
    flex-direction: column;
    /* 分类标题图与产品垂直排列 */
  }

  .category-product-list {
    flex-wrap: wrap;
    justify-content: center;
    /* 产品居中排列 */
  }

  .pro-sample {
    margin: 0 auto 20px;
    /* 分类图居中 */
  }
}

@media (max-width: 768px) {
  .top-banner {
    height: 350px;
    /* 按比例缩小banner高度 */
  }

  .banner-content {
    width: 80%;
    padding-left: 10%;
    height: auto;
    /* 取消固定高度，避免内容截断 */
    padding-top: 50px;
    padding-bottom: 50px;
  }

  .main-title {
    font-size: 30px;
    /* 按比例缩小字体 */
  }

  .introduce-header {
    margin-top: 80px;
    /* 按比例减少顶部间距 */
  }
}

@media (max-width: 576px) {

  .top-banner {
    height: 280px;
    /* 按原比例缩小，保持背景显示完整 */
    justify-content: center;
    /* 内容居中，避免左侧留白 */
  }

  .banner-content {
    width: 90%;
    padding: 40px 5%;
    text-align: center;
    /* 文字居中，适配手机阅读 */
  }

  .main-title {
    font-size: 24px;
    /* 保证文字清晰不溢出 */
  }

  .title {
    font-size: 16px;
  }

  .introduce-header {
    margin-top: 50px;
    /* 减少间距，避免内容靠下 */
  }

  .xiahuaxian {
    width: 60px;
    /* 按比例缩小下划线 */
  }

  .info-container {
    justify-content: center;
    /* 卡片居中 */
  }

  .info-player {
    width: 250px;
    /* 保留原卡片宽度，避免变形 */
    height: 330px;
    /* 保留原卡片高度，保持样式 */
    margin-bottom: 15px;
    /* 增加纵向间距，避免拥挤 */
  }

  .sample-info {
    width: 180px;
    /* 保留原卡片宽度 */
    height: 260px;
    /* 保留原卡片高度 */
    margin-bottom: 15px;
  }

  .category-img-box img {
    width: 224px;
    /* 保留原分类图尺寸 */
    height: 300px;
  }

  .pro-sampleName {
    left: 50%;
    transform: translateX(-50%);
    /* 分类标题居中，避免遮挡 */
  }
}
</style>
